import React from 'react';
import { AppComponent } from '../AppComponent';
import { Button } from '../widget/input/Button/Button';
import { FormUnit, FormUnitPadding, FormUnitSize } from '../layout/FormUnit/FormUnit';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { NumberFormatValues } from 'react-number-format';
import { BidLoginResult, BIDLoginService } from '../../services/BIDLoginService';
import { Loader } from '../widget/display/Loader/Loader';
import { THtml } from '../widget/display/THtml';
import QRCode from 'qrcode.react';

import './LoginPage.scss';

const LoginStateCancelled = ['Aborted', 'LoadingSession', 'LoginFailed_MustContact', 'LoginFailed_TooYoung'];

interface Props extends RouteComponentProps<any> { }

interface State {
	ssn: string;
	device: string;
	loginToken: string;
	loginStateCode: string;
	loginStart: number; // time in ms.
	loginErrorCount: number;
	qrCode: string;
}

class BankIdLogin extends AppComponent<Props, State> {
	guardService = this.application.services.guardService;
	sessionService = this.application.services.sessionService;

	constructor(props: Props) {
		super(props);
		this.state = {
			ssn: '',
			device: '',
			loginStateCode: '',
			loginToken: '',
			loginStart: 0,
			loginErrorCount: 0,
			qrCode: ''
		};
	}
	ssnChange = (values: NumberFormatValues) => {
		let val = values.formattedValue;
		if (!val) val = '';
		this.setState({ ssn: val });
	};
	handleLoginResult(promise: Promise<BidLoginResult>): Promise<BidLoginResult> {
		this.setState({ loginErrorCount: 0 });

		return promise.then((result) => {
			if (!result.success) {
				// if (result.tooYoung) {
				// 	this.setLoginStateCode('LoginFailed_TooYoung');
				// } else if (result.mustContact) {
				// 	this.setLoginStateCode('LoginFailed_MustContact');
				// } else {
				this.setLoginStateCode('LoginFailed');
				//}
			} else {

				this.setState({
					loginStateCode: 'LoginStarted',
					loginToken: result.token,
					loginStart: new Date().getTime(),
				});
				// Start loop to see if user has completed BankId login process.
				setTimeout(() => {
					this.checkLoginStatus();
				}, 4000);

				setTimeout(() => {
					this.collect();
				}, 1000);
			}
			return result;
		}, (error) => {
			this.setLoginStateCode('LoginFailed');
			return error;
		});
	}
	collect = () => {
		if (LoginStateCancelled.includes(this.state.loginStateCode)) {
			return;
		}

		const otherDevice = this.state.device === 'OTHER';
		if (!otherDevice) {
			return;
		}

		const autostartToken = this.state.loginToken;
		const hasAutostartToken = autostartToken && autostartToken.length > 0;
		if (!hasAutostartToken) {
			return;
		}

		this.sessionService
			.collect(autostartToken)
			.then((result) => {
				if (!result.success) {
					return;
				}

				this.setState({ qrCode: result.data });

				setTimeout(() => {
					this.collect();
				}, 1000);
			});
	}
	checkLoginStatus() {
		if (LoginStateCancelled.includes(this.state.loginStateCode)) {
			return;
		}

		this.sessionService
			.checkLoginState(this.state.loginToken)
			.then((result) => {
				let code = result.status;
				if (code === 'Complete' && !result.isComplete) code = 'NotComplete';

				if (code === 'Error') {
					const errorsSoFar = this.state.loginErrorCount;
					if (errorsSoFar > 5) {
						result.isAborted = true; // abort.
					}
					else
						this.setState({ loginErrorCount: errorsSoFar + 1 }); // increase error count.
				}

				// Auto abort after 60s.
				let timeNow = new Date().getTime();
				if (timeNow - this.state.loginStart > 60000) {
					result.isAborted = true;
				}

				this.setLoginStateCode(code);

				if (code === 'ContactBank') {
					this.setLoginStateCode('LoginFailed_MustContact');
					return;
				} else if (code === 'TooYoung') {
					this.setLoginStateCode('LoginFailed_TooYoung');
					return;
				} else if (result.isAborted) {
					this.setLoginStateCode('Aborted');
					return;
				} else if (result.isComplete) {
					this.redirectAfterOkLogin();
				} else {
					setTimeout(() => {
						this.checkLoginStatus();
					}, 2000);
				}
			});
	}
	setLoginDevice = (other: boolean): void => {
		this.setState({ device: other ? 'OTHER' : 'SAME' });
	};
	setLoginStateCode = (code: string): void => {
		if (this.state.loginStateCode !== code)
			this.setState({ loginStateCode: code });
	};
	redirectAfterOkLogin = (): void => {
		this.setLoginStateCode('LoadingSession');
		this.sessionService.loadSession().then((result) => {
			this.props.history.push('/');
		});
	}
	loginMobile = () => {
		this.setLoginDevice(true);
		this.handleLoginResult(
			this.sessionService.loginMobile(this.state.ssn)
		);
	};
	loginLocal = () => {
		this.setLoginDevice(false);
		this.handleLoginResult(
			this.sessionService.loginLocal(this.state.ssn)
		);
	};
	startLoginManually = () => {
		const autostartToken = this.state.loginToken;
		if (autostartToken)
			this.sessionService.loginWithAutostartToken(autostartToken);
	};
	cancelLogin = () => {
		this.setLoginStateCode('Aborted');
		this.setState({ loginToken: '' });
	};

	render() {
		const loginStateCode = this.state.loginStateCode;
		const canLogin =
			!loginStateCode ||
			loginStateCode === '' ||
			loginStateCode === 'LoginFailed' ||
			loginStateCode === 'Aborted' ||
			loginStateCode === 'LoginFailed_TooYoung' ||
			loginStateCode === 'LoginFailed_MustContact';
		const isLoggingIn = loginStateCode && loginStateCode.length && !canLogin;
		const otherDevice = this.state.device === 'OTHER';
		const sameDevice = !otherDevice;
		const autostartToken = this.state.loginToken;
		const hasAutostartToken = autostartToken && autostartToken.length > 0;

		return (
			<div className="BankIdLogin">

				<FormUnit size={FormUnitSize.Normal} padding={FormUnitPadding.None}>
					{!isLoggingIn && (
						<>
							<p>
								<Button
									type="button"
									className="Button orange full-width"
									labelTextkey="Login_LoginMobileBankId"
									onClick={this.loginMobile}
									enabled={canLogin}
								/>
							</p>
							<p>
								<Button
									type="button"
									className="Button orange-outline full-width"
									labelTextkey="Login_LoginLocalBankId"
									onClick={this.loginLocal}
									enabled={canLogin}
								/>
							</p>
						</>
					)}
					{isLoggingIn && otherDevice && hasAutostartToken && this.state.qrCode &&
						<div>
							{/* <div className="Paragraph"><T k="Login_ReadQrCodeWithBankID"/></div> */}
							<div className="QrCodeWrapper">
								<QRCode value={this.state.qrCode} level={"L"} size={512} renderAs="canvas" />
							</div>
						</div>
					}
					{isLoggingIn && sameDevice && (
						<FormUnit size={FormUnitSize.Normal}>
							<Loader />
						</FormUnit>
					)}
				</FormUnit>

				<p>
					{isLoggingIn && otherDevice && (
						<THtml k="BID_Status_OpenOnOtherDevice" />
					)}
					{loginStateCode === 'LoginStarted' && (
						<span>
							<THtml k="BID_Status_LoginStarted" />
						</span>
					)}
					{loginStateCode === 'LoginFailed' && (
						<span>
							<THtml k="BID_Status_LoginFailed" />
						</span>
					)}
					{loginStateCode === 'LoginFailed_TooYoung' && (
						<span className="ErrorMessage">
							<THtml k="BID_Status_LoginFailed_TooYoung" />
						</span>
					)}
					{loginStateCode === 'LoginFailed_MustContact' && (
						<span className="ErrorMessage">
							<THtml k="BIC_Status_LoginFailed_MustContact" />
						</span>
					)}
					{loginStateCode === 'Aborted' && (
						<span>
							<THtml k="BID_Status_Aborted" />
						</span>
					)}
					{loginStateCode === 'LoadingSession' && (
						<span>
							<THtml k="BID_Status_LoadingSession" />
						</span>
					)}
					{loginStateCode === 'NotComplete' && (
						<span>
							<THtml k="BID_Status_NotComplete" />
							{/*Operation is returning complete but not done.*/}
						</span>
					)}
					{loginStateCode === 'Complete' && (
						<span>
							<THtml k="BID_Status_Complete" />
							{/*Operation is complete*/}
						</span>
					)}
					{loginStateCode === 'UserSign' && (
						<span>
							<THtml k="BID_Status_UserSign" />
							{/*App has started. Waiting for user to enter PIN or password*/}
						</span>
					)}
					{loginStateCode === 'OutstandingTransaction' && (
						<span>
							<THtml k="BID_Status_OutstandingTransaction" />
							{/*Waiting for the app to start.*/}
						</span>
					)}
					{loginStateCode === 'NoClient' && (
						<span>
							<THtml k="BID_Status_NoClient" />
							{/*Waiting for the app to start.*/}
						</span>
					)}
					{loginStateCode === 'UserReq' && (
						<span>
							<THtml k="BID_Status_UserReq" />
							{/*Not used*/}
						</span>
					)}
					{loginStateCode === 'Started' && (
						<span>
							<THtml k="BID_Status_Started" />
							{/*App has started, but no eID has not been opened yet*/}
						</span>
					)}
				</p>

				<FormUnit>
					{isLoggingIn && sameDevice && hasAutostartToken &&
						<p>
							<Button
								type="button"
								className="Button green full-width"
								labelTextkey="Login_StartManually"
								onClick={this.startLoginManually}
							/>
						</p>
					}

					{isLoggingIn &&
						<Button
							type="button"
							className="Button orange full-width"
							labelTextkey="Login_Cancel"
							onClick={this.cancelLogin}
						/>
					}
				</FormUnit>
			</div>
		);
	}
}

export default withRouter(BankIdLogin);
